exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add[data-v-29be52e4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-bottom:20px}.page[data-v-29be52e4]{margin-top:20px}.avatar[data-v-29be52e4]{width:120px;height:80px}.el-icon-plus[data-v-29be52e4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px dashed #dbdbdd}.img[data-v-29be52e4]{width:100%;height:auto}[data-v-29be52e4] .form .el-dialog__body{height:60vh;overflow-y:scroll}\n", ""]);

// exports
